import React, { useState } from 'react';
import styles from './styles.module.css';
import { Button, Grid, TextField, DialogActions, CircularProgress, MenuItem, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import AccountServices from 'services/AccountServices';
import { useTranslation } from 'react-i18next';

function EditPaymentModeDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { handleClose, paymentMode, updatePaymentModes, isLoading } = props;
  const [name, setName] = useState(paymentMode.name);
  const [order, setOrder] = useState(paymentMode.order);
  const [accountHead, setAccountHead] = useState(paymentMode.account_head);
  const [accountHeads, setAccountHeads] = useState([]);

  useEffect(() => {
    const fetchHeads = async () => {
      try {
        const res = await AccountServices.getAccountHeads();
        setAccountHeads(res.results || res || []);
      } catch (err) {
        console.error("Failed to fetch account heads", err);
      }
    };
    fetchHeads();
  }, []);

  const updatePaymentModeName = () => {
    const payload = { name, account_head: accountHead };
    if (order !== '') {
      payload.order = order;
    }
    updatePaymentModes(paymentMode, payload);
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon("Edit Payment Mode")}</h2>
          <IconButton onClick={handleClose}><CloseIcon/></IconButton> 
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} sx={{ pt: 0.5 }} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon("Name")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon("Payment Mode")}
                variant="outlined"
                size="small"
                fullWidth
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} style={{ pt: 0.5 }} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon("Order")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon("Order")}
                variant="outlined"
                size="small"
                fullWidth
                value={order}
                onChange={(e) => {
                  setOrder(e.target.value === '' ? '' : Number(e.target.value));
                }}
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} style={{ pt: 0.5 }} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon("Account Head")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                select
                label={tCommon("Account Head")}
                variant="outlined"
                size="small"
                fullWidth
                value={accountHead || ''}
                onChange={(e) => {
                  setAccountHead(e.target.value);
                }}
              >
                <MenuItem value="">{tCommon("None")}</MenuItem>
                {accountHeads.map((head) => (
                  <MenuItem key={head.id} value={head.id}>
                    {head.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleClose}
              className={styles.closeBtn}
              disabled={isLoading}
            >
              {tCommon('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={name === '' || isLoading}
              onClick={updatePaymentModeName}
            >
              {isLoading ? (
                <>
                  <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                  {tCommon('Updating...')}
                </>
              ) : (
                tCommon('Update')
              )}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default EditPaymentModeDialog;
